import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children }) {
  const hasAccess = localStorage.getItem('appAccess') === 'true';

  if (!hasAccess) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;